<template>
    <div class="intro-view">
        <heading :title="title" key="intro-view-title"/>
        <b-row>
            <b-col class="col-6">
                <view-table
                    :model="intro"
                    :data="introInfo"
                    :fields="['route', 'content']"/>
            </b-col>
        </b-row>
        <b-row class="mx-1 my-4">
            <b-button
                v-if="canEdit"
                variant="primary"
                :to="`/intro/edit/${introId}`">
                Edit Intro Paragraph
            </b-button>
            <b-button
                v-if="canDelete"
                class="ml-4"
                variant="danger"
                @click="deleteTemplate()">
                Delete Intro Paragraph
            </b-button>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import Intro from '@/models/Intro'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'IntroView',
    props: {
        introId: Number,
    },
    data () {
        return {
            title: '',
            introInfo: {},
            intro: Intro,
            canEdit: false,
            canDelete: false,
        }
    },
    methods: {
        deleteTemplate: function (item) {
            if (this.canDelete) {
                this.$bvModal.msgBoxConfirm('Would you like to delete this intro paragraph? This action cannot be undone.')
                    .then(async (value) => {
                        if (value) {
                            this.$api.deleteItem(this, 'intro', this.introInfo)
                            this.$toasted.info('Intro paragraph deleted')
                            this.$router.push('/intro/list')
                        } else {
                            this.$toasted.error('Unable to delete intro paragraph')
                        }
                    })
            } else {
                this.$toasted.error(`Unable to delete intro paragraph`)
            }
        },
    },
    created () {
        this.$api.getItem(this, 'intro', this.introId)
            .then((data) => {
                this.title = data['route']
                this.introInfo = data
            })
        Authorization.can({ action: 'edit', model: 'intro', arg: this.introId })
            .then((canEdit) => this.canEdit = canEdit)
        Authorization.can({ action: 'delete', model: 'intro', arg: this.introId })
            .then((can) => this.canDelete = can)
    },
})
</script>
